import {
  SET_TABLE_COLS,
  SET_TABLE_ROWS,
  SET_TABLE_MODE,
  UPDATE_TABLE_DATA,
  UPDATE_MODAL_STATE,
  SET_METRICS_SYSTEM,
  SET_METRIC_RADIO_STATE,
  SET_CURRENT_METRIC
} from './actions';

/**
 * reducer for tableWidget
 * @param {object} state - tableWidgets state
 * @param {object} action - tableWidget actions
 * @returns {object} state - new tableWidget state
 */
export const reducer = (state, action) => {
  switch (action.type) {
    case UPDATE_MODAL_STATE:
      return { ...state, isOpen: action.isOpen };
    case UPDATE_TABLE_DATA:
      return { ...state, data: action.data };
    case SET_TABLE_ROWS:
      return { ...state, newRows: action.newRows };
    case SET_TABLE_COLS:
      return { ...state, newCols: action.newCols };
    case SET_TABLE_MODE:
      return { ...state, mode: action.mode };
    case SET_METRICS_SYSTEM:
      return { ...state, metricsSystems: action.metricsSystems };
    case SET_CURRENT_METRIC:
      return { ...state, currentMetric: action.currentMetric };
    case SET_METRIC_RADIO_STATE:
      return { ...state, metricRadioState: action.metricRadioState };
    default:
      throw new Error('Unexpected action');
  }
};
